let helperCommon = {
    data() {
        return Object.assign({
            array_delimiter: '|-|',
        });
    },
    methods: {
        _cloneObject: (source_object) => {
            return JSON.parse(JSON.stringify(source_object));
        },
        _timeConvert: (value, format = 'HH:mm:ss', value_format = "HH:mm") => {

            let date_string = '';
            if (_.size(value) == _.size(value_format))
            {
                date_string = moment(value, value_format).format(format);
            } else {
                date_string = moment(value).format(format);
            }

            return _.isNull(value) || value == '' || date_string == 'Invalid date' ?
                '' : date_string;
        },
        _dateFormatHandle: (value, format) => {
            if (_.isUndefined(format) || _.isNaN(format) || _.isNull(format))
            {
                // YYYY-MM-DD HH:mm:ss
                format = 'YYYY-MM-DD';
            }
            return _.isNull(value) || value == '' ? null : moment(value).format(format);
        },
        _objectToQueryString: (obj) =>  {
            return $.param(obj);
        },
        debugMessage(message, color_type = 'normal') {
            let style = '';
            if (_.isUndefined(color_type) || color_type == 'normal')
            {
                if (this.is_debug) console.log(message);
            } else {
                switch (color_type)
                {
                    case 'blue':
                    case 'info':
                        style = 'color:#0000ff;';
                        break;
                    case 'orange':
                    case 'warning':
                        style = 'color:#e28a00;';
                        break;
                    case 'green':
                    case 'success':
                        style = 'color:#017e8c;';
                        break;
                    case 'red':
                    case 'error':
                        style = 'color:#ff0000;';
                        break;
                    case 'gray':
                        style = 'color:#afafaf;';
                        break;
                }
                if (this.is_debug) console.log('%c' + message, style);
            }
        },
        _integerOnly(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            let key = evt.charCode || evt.keyCode || 0;

            let status = (
                (key == 9) ||
                (key == 8) || (key == 46) ||
                (key == 110) || (key == 190) ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105) ||
                evt.ctrlKey && (key == 65 || key == 67 || key == 86)
            );

            if (status) {
                return true;
            } else {
                evt.preventDefault();
            }
        },
        _countChar(str, ch) {
            return _.countBy(str)[ch] || 0;
        },
        _numberOnly(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            let key = evt.charCode || evt.keyCode || 0;

            let status = (
                (key == 9) ||
                (key == 8) || (key == 46) ||
                (key == 110) || (key == 190) ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105) ||
                evt.ctrlKey && (key == 65 || key == 67 || key == 86)
            );

            if (status && (key == 110 || key == 190) && this._countChar(evt.target.value,'.') > 0)
            {
                status = false;
            }

            if (status) {
                return true;
            } else {
                evt.preventDefault();
            }
        },
        _pluckByKey(objects, key) {
            let outputArray = [];
            _.forEach(objects, (object) => {
                if (!_.isUndefined(object[key]))
                {
                    outputArray.push(object[key]);
                }
            });
            return outputArray;
        },
        moneyDisplay(value) {
            if (value == null) {
                return '--';
            } else {
                // User is not modifying now. Format display value for user interface
                if (typeof value == 'string') {
                    value = parseFloat(value);
                }
                if (value >= 0) {
                    return "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
                } else {
                    let abs_value = Math.abs(value);
                    return "-$" + abs_value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
                }
            }
        }
    }
};

/* tab */
let helperTabs = {
    mixins: [helperCommon],
    data() {
        return Object.assign({
            helper_tabs_element: {
                active_tab: '',
                tab: '',
                tab_info: {},
            }
        });
    },
    methods: {
        _defineTabObject(item, element_id, default_value) {
            let self = this;
            if (_.isUndefined(self.helper_tabs_element[item]))
            {
                this.$set(self.helper_tabs_element, item, {});
            }
            if (_.isUndefined(element_id))
            {
                element_id = self.element_id;
            }
            if (_.isUndefined(self.helper_tabs_element[item][element_id]))
            {
                this.$set(self.helper_tabs_element[item], element_id, default_value);
            }
        },
        _changeTab(tab) {
            if (!_.isUndefined(this.helper_tabs_element.tab_info[tab]))
            {
                if (_.isUndefined(this.helper_tabs_element.tab_info[tab]['custom_url']))
                {
                    location.href = this.helper_tabs_element.tab_info[tab]['url_holder'] + '/' + this.helper_tabs_element.tab_info[tab]['url_segment'];
                } else {
                    location.href = this.helper_tabs_element.tab_info[tab]['custom_url'];
                }
            }
        },
    }
};

/* Modal Editing */
let helperModalEdit = {
    mixins: [helperCommon],
    data() {
        return Object.assign({
            tableRecords: {},
            helper_modal_element: {
                time_columns: [],
                date_columns: [],
                datetime_columns: [],
                element_id: 'default',
                edit_record: {},
                current_record: {},
                edit_record_modal: {},
                delete_record_modal: {},
            }
        });
    },
    methods: {
        _defineModalObject(item, element_id, default_value) {
            let self = this;
            if (_.isUndefined(self.helper_modal_element[item]))
            {
                this.$set(self.helper_modal_element, item, {});
            }
            if (_.isUndefined(element_id))
            {
                element_id = self.element_id;
            }
            if (_.isUndefined(self.helper_modal_element[item][element_id]))
            {
                this.$set(self.helper_modal_element[item], element_id, default_value);
            }
        },
        _defineModalEditElement(element_id, edit_record = {})
        {
            let self = this;
            self._defineModalObject('edit_record_modal', element_id, false);
            self._defineModalObject('delete_record_modal', element_id, false);
            self._defineModalObject('edit_record', element_id, edit_record);
            self._defineModalObject('tableRecords', element_id, {});
        },
        _setCurrentRecord(record) {
            let self = this;
            self.helper_modal_element.current_record = self._cloneObject(record);
            self.$store.commit('setValidationError', []);
        },
        _addRecord(element_id) {
            let self = this;
            self._setCurrentRecord(self.helper_modal_element.edit_record[element_id]);
            self.helper_modal_element.current_record.id = '';
            self.helper_modal_element.current_record.key = null;
            self.helper_modal_element.edit_record_modal[element_id] = true;
        },
        _editRecord(element_id, key) {
            let self = this;
            self._setCurrentRecord(self.tableRecords[element_id].data[key]);
            self.helper_modal_element.current_record.key = key;
            self.helper_modal_element.edit_record_modal[element_id] = true;
        },
        _deleteRecord(element_id, key) {
            let self = this;
            self._setCurrentRecord(self.tableRecords[element_id].data[key]);
            self.helper_modal_element.current_record.key = key;

            self._toggleDeleteModal(element_id, true)
        },
        _toggleDeleteModal(element_id, modal_status = true) {
            let self = this;
            if (!_.isUndefined(self.helper_modal_element.delete_record_modal[element_id]))
            {
                self.helper_modal_element.delete_record_modal[element_id] = modal_status;
            }
        },
        _toggleEditModel(element_id, modal_status = true, item_key)
        {
            let self = this;
            if (modal_status)
            {
                if (_.isUndefined(item_key))
                {
                    self._addRecord(element_id);
                } else {
                    self._editRecord(element_id, item_key);
                }
            } else {
                self.helper_modal_element.edit_record_modal[element_id] = false;
            }
        },
        _getModalFormData()
        {
            let self = this;
            return self._cloneObject(self.helper_modal_element.current_record);
        }
    },
    watch: {}
};

/* Table Select All */
let helperTableSelectAll = {
    mixins: [helperCommon],
    data() {
        return Object.assign({
            tableRecords: {},
            helper_select_all_element: {
                element_id: 'defaultTable',
                select_all: {},
                is_click_from: {},
                no_of_records: {},
                selected_elements: {},
            },
        });
    },
    beforeMount() {

    },
    methods: {
        _defineTableObject(item, element_id, default_value) {
            let self = this;
            if (_.isUndefined(self.helper_select_all_element[item]))
            {
                this.$set(self.helper_select_all_element, item, {});
            }
            if (_.isUndefined(element_id))
            {
                element_id = self.element_id;
            }
            if (_.isUndefined(self.helper_select_all_element[item][element_id]))
            {
                this.$set(self.helper_select_all_element[item], element_id, default_value);
            }
        },
        _defineTableElement(element_id)
        {
            let self = this;
            self._defineTableObject('select_all', element_id, false);
            self._defineTableObject('is_click_from', element_id, 'item');
            self._defineTableObject('no_of_records', element_id, 0);
            self._defineTableObject('selected_elements', element_id, []);
            self._defineTableObject('tableRecords', element_id, {});
        },
        _getSelectedItems(element_id) {
            let self = this;
            return self.helper_select_all_element.selected_elements[element_id];
        },
        _clearSelectedItems(element_id) {
            let self = this;
            self.helper_select_all_element.selected_elements[element_id] = [];
        },
        // click Check box action
        _clickCheckBox(elm, element_id) {
            let self = this;
            self.helper_select_all_element.is_click_from[element_id] = elm;
        },
        _assignSelected(element_id, table_data, key_field = 'id') {
            let self = this;
            let key_array = [];

            _.forEach(self.helper_select_all_element.selected_elements[element_id], (selected) => {
                key_array.push(selected[key_field]);
            });
            if (_.size(key_array) > 0) {
                _.forEach(table_data.data, (record, key) => {
                    if (_.indexOf(key_array, record[key_field]) != -1) {
                        if (_.isUndefined(table_data.data[key].selected)) {
                            this.$set(table_data.data[key], 'selected', true);
                        } else {
                            table_data.data[key].selected = true;
                        }
                    }
                });
            }

            return table_data;
        }
    },
    watch: {
        'helper_select_all_element.select_all': {
            handler(after, before) {
                let self = this;
                _.forEach(self.helper_select_all_element.is_click_from, (click_form, element_id) => {
                    if (click_form == 'select_all') {
                        _.forEach(self.tableRecords[element_id].data, (selectedElement, index) => {
                            if (_.isUndefined(self.tableRecords[element_id].data[index].selected)) {
                                this.$set(self.tableRecords[element_id].data[index], 'selected', true);
                            } else {
                                self.tableRecords[element_id].data[index].selected = self.helper_select_all_element.select_all[element_id];
                            }
                        });
                    }
                });
            },
            deep:true
        },
        'tableRecords': {
            handler(after, before) {
                let self = this;
                _.forEach(self.tableRecords, (tableInfo, element_id) => {
                    // reset Selected All
                    self.helper_select_all_element.selected_elements[element_id] = [];
                    self.helper_select_all_element.no_of_records[element_id] = 0;
                    // get Selected item
                    if (!_.isUndefined(tableInfo.data) && _.size(tableInfo.data) > 0)
                    {
                        _.forEach(tableInfo.data, (record, key) => {
                            if (!_.isUndefined(record.selected) && record.selected) {
                                self.helper_select_all_element.selected_elements[element_id].push(record);
                            }
                        })
                        // update total records
                        self.helper_select_all_element.no_of_records[element_id] = _.size(self.helper_select_all_element.selected_elements[element_id]);
                    }

                    // handle checkbox hide/show
                    if (self.helper_select_all_element.is_click_from[element_id] != 'select_all')
                    {
                        if (self.helper_select_all_element.no_of_records[element_id] == _.size(self.tableRecords[element_id].data))
                        {
                            self.helper_select_all_element.select_all[element_id] = true;
                        } else {
                            self.helper_select_all_element.select_all[element_id] = false;
                        }
                    }
                });
            },
            deep:true
        }
    }
};

let helperTableExpand = {
    mixins: [helperCommon],
    data() {
        return Object.assign({
            tableRecords: {},
            helper_expand_element: {

            },
        });
    },
    beforeMount() {

    },
    watch: {
    },
    methods: {
        _defineTableObject(item, element_id, default_value) {
            let self = this;
            if (_.isUndefined(self.helper_expand_element[item]))
            {
                this.$set(self.helper_expand_element, item, {});
            }
            if (_.isUndefined(element_id))
            {
                element_id = self.element_id;
            }
            if (_.isUndefined(self.helper_expand_element[item][element_id]))
            {
                this.$set(self.helper_expand_element[item], element_id, default_value);
            }
        },
        _defineTableElement(element_id)
        {
            let self = this;
            self._defineTableObject('expand_status', element_id, false);
            self._defineTableObject('edit_type', element_id, 'single');
            self._defineTableObject('full_edit', element_id, false);
            self._defineTableObject('no_of_editing', element_id, 0);
        },
        _expandToggleRecords(element_id, status, key)
        {
            let self = this;
            if (_.isUndefined(key))
            {
                if (_.isUndefined(status) || _.isNull(status)) {
                    self.helper_expand_element.expand_status[element_id] = !self.helper_expand_element.expand_status[element_id];
                } else {
                    self.helper_expand_element.expand_status[element_id] = status;
                }
            }

            if (_.size(self.tableRecords[element_id].data) > 0) {
                if (_.isUndefined(key))
                {
                    _.forEach(self.tableRecords[element_id].data, (row, key) => {
                        row.expanded = self.helper_expand_element.expand_status[element_id];
                    });
                } else {
                    if (!_.isUndefined(self.tableRecords[element_id].data[key])) {
                        if (_.isUndefined(status) || _.isNull(status)) {
                            self.tableRecords[element_id].data[key].expanded = !self.tableRecords[element_id].data[key].expanded;
                        } else {
                            self.tableRecords[element_id].data[key].expanded = status;
                        }
                        if (!self.tableRecords[element_id].data[key].expanded)
                        {
                            self.helper_expand_element.expand_status[element_id] = false;
                        }
                    }
                }
            }
        },
        _changeEditType(element_id, type='single', key = null)
        {
            let self = this;
            self.helper_expand_element.full_edit[element_id] = false;
            if (!_.isUndefined(self.tableRecords[element_id].data))
            {
                if (_.isUndefined(key) || _.isNull(key)) {
                    self.helper_expand_element.full_edit[element_id] = true;
                }

                if (type == 'full')
                {
                    self.helper_expand_element.edit_type[element_id] = type;
                    if (_.size(self.tableRecords[element_id].data) > 0) {

                        self.helper_expand_element.no_of_editing[element_id] = _.size(self.tableRecords[element_id].data);

                        _.forEach(self.tableRecords[element_id].data, (row, key) => {
                            self.tableRecords[element_id].data[key].editing = true;

                            if (!_.isUndefined(self.tableRecords[element_id].data[key].org_labels) &&
                                !_.isUndefined(self.tableRecords[element_id].data[key].update_labels))
                            {
                                self.tableRecords[element_id].data[key].update_labels = self._cloneObject(self.tableRecords[element_id].data[key].org_labels);
                            }

                            if (!_.isUndefined(self.tableRecords[element_id].data[key].org_data) &&
                                !_.isUndefined(self.tableRecords[element_id].data[key].update_data))
                            {
                                self.tableRecords[element_id].data[key].update_data = self._cloneObject(self.tableRecords[element_id].data[key].org_data);
                            }
                            if (!_.isUndefined(self.tableRecords[element_id].data[key].right))
                            {
                                _.forEach(self.tableRecords[element_id].data[key].right, (right_item) => {
                                    right_item = false;
                                });
                            }
                        });
                    }
                } else {
                    self.helper_expand_element.edit_type[element_id] = type;
                    if (_.size(self.tableRecords[element_id].data) > 0 &&
                        !_.isUndefined(self.tableRecords[element_id].data[key])) {

                        self.tableRecords[element_id].data[key].editing = true;

                        if (!_.isUndefined(self.tableRecords[element_id].data[key].org_labels) &&
                            !_.isUndefined(self.tableRecords[element_id].data[key].update_labels))
                        {
                            self.tableRecords[element_id].data[key].update_labels = self._cloneObject(self.tableRecords[element_id].data[key].org_labels);
                        }

                        if (!_.isUndefined(self.tableRecords[element_id].data[key].org_data) &&
                            !_.isUndefined(self.tableRecords[element_id].data[key].update_data))
                        {
                            self.tableRecords[element_id].data[key].update_data = self._cloneObject(self.tableRecords[element_id].data[key].org_data);
                        }

                        _.forEach(self.tableRecords[element_id].data[key].right, (right_item) => {
                            right_item = false;
                        });

                        let editing_records = _.filter(self.tableRecords[element_id].data, (item) => {
                            return item.editing && item.can_edit;
                        });
                        self.helper_expand_element.no_of_editing[element_id] = _.size(editing_records);
                    }
                }
            }
        },
        _closeEditType(element_id, key)
        {
            let self = this;
            if (_.isUndefined(key))
            {
                if (_.size(self.tableRecords[element_id].data) > 0)
                {
                    _.forEach(self.tableRecords[element_id].data, (item, key) => {
                        self.tableRecords[element_id].data[key].editing = false;
                    });
                }
            } else {
                if (_.size(self.tableRecords[element_id].data) > 0 &&
                    !_.isUndefined(self.tableRecords[element_id].data[key])) {
                    self.tableRecords[element_id].data[key].editing = false;
                }
            }
            self.helper_expand_element.edit_type[element_id] = 'single';
            self.helper_expand_element.full_edit[element_id] = false;

            let editing_records = _.filter(self.tableRecords[element_id].data, (item) => {
                return item.editing && item.can_edit;
            });
            self.helper_expand_element.no_of_editing[element_id] = _.size(editing_records);
        }
    }
}

export { helperCommon, helperModalEdit, helperTableSelectAll, helperTabs, helperTableExpand };



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/helper.common.js